// extracted by mini-css-extract-plugin
export var active = "header-module--active--byAzz";
export var activeChild = "header-module--activeChild--+YfWE";
export var arrow = "header-module--arrow--YjFj2";
export var arrowReverse = "header-module--arrowReverse--MuSXG";
export var buttonContainer = "header-module--buttonContainer--6aS96";
export var childMenu = "header-module--childMenu--SCrrB";
export var childMenuTitle = "header-module--childMenuTitle--cK7UO";
export var childMenuTitleContainer = "header-module--childMenuTitleContainer--cE20W";
export var childNav = "header-module--childNav--TZB40";
export var eduWorkLink = "header-module--eduWorkLink--LB4AW";
export var eduWorkLinks = "header-module--eduWorkLinks--XhGG5";
export var gradient = "header-module--gradient--fXhAs";
export var gradientBlock = "header-module--gradientBlock--46kXu";
export var headerIcon = "header-module--headerIcon--7Jlrv";
export var headerMenu = "header-module--headerMenu--r9FAo";
export var headerWrapper = "header-module--headerWrapper--ziG6T";
export var language = "header-module--language--A4F66";
export var logo = "header-module--logo--WAoX3";
export var logotype = "header-module--logotype--sDp2J";
export var mainHeader = "header-module--mainHeader--j2hcC";
export var menu = "header-module--menu--hMDNj";
export var menuIcon = "header-module--menuIcon--jXsgu";
export var mobileHeader = "header-module--mobileHeader--J6XwG";
export var navLink = "header-module--navLink--lqZvw";
export var navTitle = "header-module--navTitle--E8-mH";
export var navigation = "header-module--navigation--Ri0Ak";
export var open = "header-module--open--AyHsV";
export var primaryBlock = "header-module--primaryBlock--DfZTz";
export var sbShowMain = "header-module--sb-show-main--PO8pK";
export var search = "header-module--search--Hpy6K";
export var searchHeader = "header-module--searchHeader--Fv-jB";
export var secondaryBlock = "header-module--secondaryBlock--zJffI";
export var shadow = "header-module--shadow--3RwiD";
export var slider = "header-module--slider--irNxu";
export var splitList = "header-module--splitList--VHDPN";
export var subheader = "header-module--subheader--b97WD";
export var title = "header-module--title--gXera";